import TemplateLayout from "../../../../../providers/TemplateLayout";
import React from "react";
import { useDispatch } from "react-redux";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { getUser } from "../../../../../store/slices/auth-slice";
import { useAppSelector } from "../../../../../hooks/app";
import { ROLES } from "../../../../../constants";

function SoloCrossCountryOne({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [aircraftType, setAircraftType] = React.useState("");
  const [flight, setFlight] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received the required solo cross-country training. I find [he or she] has met the applicable requirements of §61.93, and is proficient to make solo cross-country flights in a ${flight} aircraft, ${aircraftType} [aircraft category]. CFR §1552.3(h).`;
    dispatch(setTemplateText(templateText));
  }, [name, aircraftType, flight, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR:61.103(f), 61.107(b), and 61.109</label>
      </div>
      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that{" "}
          <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required solo cross-country training. I find [he or she] has met the applicable requirements of §61.93, and is proficient to make solo cross-country flights in a
          <input
            type="text"
            onChange={(e) => setFlight(e.target.value)}
            style={{ margin: '0 5px' }}
          /> aircraft, <input
            type="text"
            onChange={(e) => setAircraftType(e.target.value)}
            style={{ margin: '0 5px' }}
          /> [aircraft category]. CFR §1552.3(h).
        </p>
      </div>
    </TemplateLayout>
  );
}

export default SoloCrossCountryOne;
